import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Tour from "./views/Tour.vue";

Vue.use(Router);

export default new Router({
  // mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/us'
    },
    {
      path: '/p',
      redirect: '/us/p'
    },
    {
      path: '/:lang',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: "/",
          name: "home",
          component: Home
        }, {
          path: "p",
          name: "tour",
          component: Tour
        }
      ]
    }
  ]
});
